import { ContentSourceDetailsFragment } from '~/graphqlTypes/ContentSourceDetailsFragment';
import getContentSourceByIdQuery from './GetContentSourceByIdQuery.gql';
import { ModelReference, ModelReferenceDescriptor, createReferenceFactory } from './ModelReference';
import { getClient } from '~/apollo/client';
import {
  GetContentSourceByIdQuery,
  GetContentSourceByIdQueryVariables,
} from '~/graphqlTypes/GetContentSourceByIdQuery';

export type ContentSourceReference = ModelReference<ContentSourceDetailsFragment, 'id'>;

export const contentSourceReference = createReferenceFactory<ContentSourceDetailsFragment, 'id'>(
  'ContentSource',
  'id',
  async ( id ) => {
    const apolloClient = getClient();

    const results = await apolloClient.query<GetContentSourceByIdQuery, GetContentSourceByIdQueryVariables>( {
      query: getContentSourceByIdQuery,
      variables: { id },
    } );

    const item = results.data.contentSourceById;

    if ( item.__typename === 'NotFoundError' ) {
      throw new Error( `Content Source with id ${id} not found` );
    }

    return item;
  },
);

export type ContentSourceReferenceDescriptor = ModelReferenceDescriptor<ContentSourceDetailsFragment, 'id'>;
